type State = {
  monthlyDeclarations: Record<string, string>;
  monthlyDeclarationErrors: Record<string, string>;
  selectedIds: string[];
  yearlyDeclarationAmountValues: Record<string, string>;
};

type Action =
  | {
      type: 'SET_MONTHLY_DECLARATIONS';
      payload: {
        id: string;
        value: string;
      }[];
    }
  | {
      type: 'MONTHLY_DECLARATION_CHANGE';
      payload: { id: string; value: string };
    }
  | {
      type: 'SET_SELECTED_IDS';
      payload: string[];
    }
  | {
      type: 'SET_ERRORS';
      payload: Record<string, string>;
    }
  | {
      type: 'SET_YEARLY_DECLARATION_AMOUNT_VALUES';
      payload: Record<string, string>;
    }
  | {
      type: 'YEARLY_DECLARATION_IN_AMOUNT_CHANGE';
      payload: { id: string; value: string };
    };

export const fbpAssignmentsReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_MONTHLY_DECLARATIONS': {
      const monthlyDeclarations: Record<string, string> = {};
      const monthlyDeclarationErrors: Record<string, string> = {};

      action.payload.forEach((node) => {
        monthlyDeclarations[node.id] = node.value;
        monthlyDeclarationErrors[node.id] = '';
      });

      return {
        ...state,
        monthlyDeclarations,
        monthlyDeclarationErrors,
      };
    }

    case 'SET_YEARLY_DECLARATION_AMOUNT_VALUES': {
      return {
        ...state,
        yearlyDeclarationAmountValues: action.payload,
      };
    }

    case 'MONTHLY_DECLARATION_CHANGE': {
      const { id, value } = action.payload;

      if (state.monthlyDeclarations[id] === value) {
        return state;
      }

      return {
        ...state,
        monthlyDeclarations: {
          ...state.monthlyDeclarations,
          [id]: value,
        },
        monthlyDeclarationErrors: {
          ...state.monthlyDeclarationErrors,
          [id]: '',
        },
      };
    }

    case 'YEARLY_DECLARATION_IN_AMOUNT_CHANGE':
      const { id, value } = action.payload;

      if (value === state.yearlyDeclarationAmountValues[id]) return state;

      return {
        ...state,
        yearlyDeclarationAmountValues: {
          ...state.yearlyDeclarationAmountValues,
          [id]: value,
        },
      };

    case 'SET_SELECTED_IDS':
      return {
        ...state,
        selectedIds: Array.from(new Set(action.payload)),
      };

    case 'SET_ERRORS':
      return {
        ...state,
        monthlyDeclarationErrors: action.payload,
      };

    default:
      return state;
  }
};
